module.exports = __webpack_public_path__ + "static/media/IMG_0307_Reduced.a2222bf7.jpg";